import { ForwardRefExoticComponent, RefAttributes } from "react";
import { TextFieldProps } from "material-ui";
import { ProductReferenceResponseWithType } from "../../../../../api/models/ProductReferenceResponse";
import { TesaPrototype } from "../../../../../api/models/product/TesaPrototype";
import PrototypeSampleAddFormType from "../../../../../api/models/product/PrototypeSampleAddFormType";
import CustomSearchAutocomplete, {
  CustomSearchAutocompleteProps,
} from "../../../../../components/Autocomplete/CustomSearchAutoComplete";

export const PrototypeSearchAutocomplete = CustomSearchAutocomplete as ForwardRefExoticComponent<
  MergedProps<CustomSearchAutocompleteProps<TesaPrototype>, TextFieldProps> & RefAttributes<{ reset: () => void }>
>;

export interface PrototypeSampleAddFormProps {
  preset?: ProductReferenceResponseWithType | null;
  halfWidth?: boolean;
  hideSubmit?: boolean;
  handleFormChange?: (values: PrototypeSampleAddFormType | null) => void;
  handleSubmit?: (values: PrototypeSampleAddFormType) => void;
  disabled?: boolean;
  suggestion?: string;
  notFoundLink?: boolean;
}
